import { tuple } from "../../utils";
export const DEFAULTS = {
    colors: tuple("primary", "success", "info", "warning", "danger", "light", "dark", "white", "black", "link"),
    shades: tuple("black-bis", "black-ter", "grey-darker", "grey-dark", "grey", "grey-light", "grey-lighter", "white-ter", "white-bis"),
    floatPulledAlignments: tuple("left", "right"),
    breakpoints: tuple("mobile", "tablet", "desktop", "widescreen", "fullhd", "touch"),
    breakpointsLimited: tuple("mobile", "fullhd", "touch"),
    textAlignments: tuple("centered", "justified", "left", "right"),
    textSizes: tuple(1, 2, 3, 4, 5, 6),
    textTransforms: tuple("capitalized", "lowercase", "uppercase"),
    textWeights: tuple("light", "normal", "semibold", "bold"),
    displays: tuple("block", "flex", "inline", "inline-block", "inline-flex"),
};
//# sourceMappingURL=variables.js.map